import * as React from "react";
import { Block, BlockProps } from "baseui/block";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type VerticalSpacerProps = {
  gap?: "section" | "inner-section";
  children: React.ReactNode[];
} & BlockProps;
export const VerticalSpacer: React.FC<VerticalSpacerProps> = (props) => {
  const [, theme] = useStyletron();
  const { children = [], gap = "section", ...restProps } = props;
  const gaps = {
    section: theme.sizing.scale700,
    "inner-section": theme.sizing.scale600,
  };
  return (
    <Block display="flex" flexDirection="column" gridRowGap={gaps[gap]} {...restProps}>
      {children?.map((child, index) => {
        return child && <Block key={index}>{child}</Block>;
      })}
    </Block>
  );
};
